import React from 'react';
import './Checkout.css';
import { useStateValue } from './StateProvider';
import BasketItem from './BasketItem';
import Subtotal from './Subtotal';


//icons
import SecurityIcon from '@material-ui/icons/Security';



function Checkout() {




    const [{ basket }, dispatch] = useStateValue();

    return (
        <div className="checkout container-fluid row">
            {/* <center><h1>Thank For Buying 💰 ! Please visit again! 🙋  </h1></center>
            <br /> */}
            <div className=" col-md-8 col-sm-12">

                <p className="checkout__banner">
                    <SecurityIcon />
                Safe and Secure Payments.Easy returns.100% Authentic products.
                </p>
                <h2 className="checkout_title"> Shopping Basket 🧺  </h2>

                {
                    basket.map(el => <BasketItem item={el} key={el.id} />)
                }



            </div>
            <div className="checkout__right col">
                <p className="checkout__banner"><span className="emoji" >💸</span>Payment Summary</p>

                <Subtotal Remove />


            </div>


        </div>
    )
}

export default Checkout;
